import React, { PropsWithChildren } from 'react';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import { useCurrency } from '@hooks/useCurrency';

interface Props extends PropsWithChildren {
  components?: string;
  enableFunding?: string[];
  disableFunding?: string[];
}

export const PayPalProvider: React.FC<Props> = ({ children, components, enableFunding, disableFunding }) => {
  const { currency } = useCurrency();

  return (
    <PayPalScriptProvider
      options={{
        clientId: process.env.PAYPAL_CLIENT_ID!,
        currency: currency.letterCode,
        components: components || 'messages,buttons',
        enableFunding: enableFunding || ['credit'],
        disableFunding: disableFunding || ['card'],
        debug: false
      }}
      deferLoading={false}
    >
      {children}
    </PayPalScriptProvider>
  );
};
